export default function getCalendarNavigationProps({
  calendarKey,
  totalCalendars,
}: {
  calendarKey?: number;
  totalCalendars: number;
}) {
  const additionalProps: { [key: string]: boolean } = {};

  if (totalCalendars > 1) {
    if (calendarKey === 0) {
      // display back arrow on first calendar
      additionalProps.hideForward = true;
    } else if (calendarKey === totalCalendars - 1) {
      // display forward arrow on last calendar
      additionalProps.hideBack = true;
    } else {
      // hide arrows on middle calendars
      additionalProps.hideForward = true;
      additionalProps.hideBack = true;
    }
  }

  return additionalProps;
}
